import { render, staticRenderFns } from "./Vas10Question.vue?vue&type=template&id=5ba06e55&scoped=true"
import script from "./Vas10Question.vue?vue&type=script&lang=js"
export * from "./Vas10Question.vue?vue&type=script&lang=js"
import style0 from "./Vas10Question.vue?vue&type=style&index=0&id=5ba06e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba06e55",
  null
  
)

export default component.exports